//各コードのデータ
type AccidentalKind = 0 | 1 | 2; //0:符号なし,1:シャープ,2:フラット
type Line = {
  //追加の線
  position: boolean[]; //線の付く場所true(配列位置の音)
};
type Accidental = {
  kind: AccidentalKind[]; //符号配列
};
export type ChordType = {
  name: string;
  name2?: string; //♯と#用
  notes: 3 | 4;
  lineG?: Line;
  lineF?: Line;
  accidental?: Accidental;
};
/*コード名,音の数,ト音追加横線,へ音追加横線,変化記号*/

export const ChordList: ChordType[] = [
  { name: "C", notes: 3, lineG: { position: [true] } },
  {
    name: "C7",
    notes: 4,
    lineG: { position: [true] },
    accidental: { kind: [0, 0, 0, 2] },
  },
  { name: "CM7", notes: 4, lineG: { position: [true] } },
  { name: "C6", notes: 4, lineG: { position: [true] } },
  { name: "Cadd9", notes: 4, lineG: { position: [true] } },
  { name: "Csus4", notes: 3, lineG: { position: [true] } },
  {
    name: "C7sus4",
    notes: 4,
    lineG: { position: [true] },
    accidental: { kind: [0, 0, 0, 2] },
  },
  {
    name: "Cm",
    notes: 3,
    lineG: { position: [true] },
    accidental: { kind: [0, 2] },
  },
  {
    name: "Cm7",
    notes: 4,
    lineG: { position: [true] },
    accidental: { kind: [0, 2, 0, 2] },
  },
  {
    name: "CmM7",
    notes: 4,
    lineG: { position: [true] },
    accidental: { kind: [0, 2] },
  },
  {
    name: "Cm7-5",
    notes: 4,
    lineG: { position: [true] },
    accidental: { kind: [0, 2, 2, 2] },
  },
  {
    name: "Cm6",
    notes: 4,
    lineG: { position: [true] },
    accidental: { kind: [0, 2] },
  },
  {
    name: "Caug",
    notes: 3,
    lineG: { position: [true] },
    accidental: { kind: [0, 0, 1] },
  },
  {
    name: "Cdim",
    notes: 4,
    lineG: { position: [true] },
    accidental: { kind: [0, 2, 2] },
  },
  {
    name: "D♭",
    notes: 3,
    accidental: { kind: [2, 0, 2] },
  },
  {
    name: "D♭7",
    notes: 4,
    lineF: { position: [false, false, false, true] },
    accidental: { kind: [2, 0, 2, 2] },
  },
  {
    name: "D♭M7",
    notes: 4,
    lineF: { position: [false, false, false, true] },
    accidental: { kind: [2, 0, 2] },
  },
  {
    name: "D♭6",
    notes: 4,
    lineF: { position: [false, false, false, true] },
    accidental: { kind: [2, 0, 2, 2] },
  },
  {
    name: "D♭add9",
    notes: 4,
    accidental: { kind: [2, 2, 0, 2] },
  },
  {
    name: "D♭sus4",
    notes: 3,
    accidental: { kind: [2, 2, 2] },
  },
  {
    name: "D♭7sus4",
    notes: 4,
    lineF: { position: [false, false, false, true] },
    accidental: { kind: [2, 2, 2, 2] },
  },
  {
    name: "D♭m",
    notes: 3,
    accidental: { kind: [2, 2, 2] },
  },
  {
    name: "D♭m7",
    notes: 4,
    lineF: { position: [false, false, false, true] },
    accidental: { kind: [2, 2, 2, 2] },
  },
  {
    name: "D♭mM7",
    notes: 4,
    lineF: { position: [false, false, false, true] },
    accidental: { kind: [2, 2, 2] },
  },
  {
    name: "D♭m7-5",
    notes: 4,
    lineF: { position: [false, false, false, true] },
    accidental: { kind: [2, 2, 0, 2] },
  },
  {
    name: "D♭m6",
    notes: 4,
    accidental: { kind: [2, 2, 2, 2] },
  },
  { name: "D♭aug", notes: 3, accidental: { kind: [2] } },
  {
    name: "D♭dim",
    notes: 4,
    accidental: { kind: [2, 2, 0, 2] },
  },
  { name: "D", notes: 3, accidental: { kind: [0, 1] } },
  {
    name: "D7",
    notes: 4,
    lineF: { position: [false, false, false, true] },
    accidental: { kind: [0, 1] },
  },
  {
    name: "DM7",
    notes: 4,
    lineF: { position: [false, false, false, true] },
    accidental: { kind: [0, 1, 0, 1] },
  },
  { name: "D6", notes: 4, accidental: { kind: [0, 1] } },
  {
    name: "Dadd9",
    notes: 4,
    accidental: { kind: [0, 0, 1] },
  },
  { name: "Dsus4", notes: 3 },
  {
    name: "D7sus4",
    notes: 4,
    lineF: { position: [false, false, false, true] },
  },
  { name: "Dm", notes: 3 },
  { name: "Dm7", notes: 4, lineF: { position: [false, false, false, true] } },
  {
    name: "DmM7",
    notes: 4,
    lineF: { position: [false, false, false, true] },
    accidental: { kind: [0, 0, 0, 1] },
  },
  {
    name: "Dm7-5",
    notes: 4,
    lineF: { position: [false, false, false, true] },
    accidental: { kind: [0, 0, 2] },
  },
  { name: "Dm6", notes: 4 },
  {
    name: "Daug",
    notes: 3,
    accidental: { kind: [0, 1, 1] },
  },
  {
    name: "Ddim",
    notes: 4,
    accidental: { kind: [0, 0, 2, 2] },
  },
  {
    name: "E♭",
    notes: 3,
    accidental: { kind: [2, 0, 2] },
  },
  {
    name: "E♭7",
    notes: 4,
    lineF: { position: [false, false, false, true] },
    accidental: { kind: [2, 0, 2, 2] },
  },
  {
    name: "E♭M7",
    notes: 4,
    lineF: { position: [false, false, false, true] },
    accidental: { kind: [2, 0, 2] },
  },
  {
    name: "E♭6",
    notes: 4,
    lineF: { position: [false, false, false, true] },
    accidental: { kind: [2, 0, 2] },
  },
  {
    name: "E♭add9",
    notes: 4,
    accidental: { kind: [2, 0, 0, 2] },
  },
  {
    name: "E♭sus4",
    notes: 3,
    accidental: { kind: [2, 2, 2] },
  },
  {
    name: "E♭7sus4",
    notes: 4,
    lineF: { position: [false, false, false, true] },
    accidental: { kind: [2, 2, 2, 2] },
  },
  {
    name: "E♭m",
    notes: 3,
    accidental: { kind: [2, 2, 2] },
  },
  {
    name: "E♭m7",
    notes: 4,
    lineF: { position: [false, false, false, true] },
    accidental: { kind: [2, 2, 2, 2] },
  },
  {
    name: "E♭mM7",
    notes: 4,
    lineF: { position: [false, false, false, true] },
    accidental: { kind: [2, 2, 2] },
  },
  {
    name: "E♭m7-5",
    notes: 4,
    lineF: { position: [false, false, false, true] },
    accidental: { kind: [2, 2, 0, 2] },
  },
  {
    name: "E♭m6",
    notes: 4,
    lineF: { position: [false, false, false, true] },
    accidental: { kind: [2, 2, 2] },
  },
  { name: "E♭aug", notes: 3, accidental: { kind: [2] } },
  {
    name: "E♭dim",
    notes: 4,
    lineF: { position: [false, false, false, true] },
    accidental: { kind: [2, 2] },
  },
  { name: "E", notes: 3, accidental: { kind: [0, 1] } },
  {
    name: "E7",
    notes: 4,
    lineF: { position: [false, false, false, true] },
    accidental: { kind: [0, 1] },
  },
  {
    name: "EM7",
    notes: 4,
    lineF: { position: [false, false, false, true] },
    accidental: { kind: [0, 1, 0, 1] },
  },
  {
    name: "E6",
    notes: 4,
    lineF: { position: [false, false, false, true] },
    accidental: { kind: [0, 1, 0, 1] },
  },
  {
    name: "Eadd9",
    notes: 4,
    accidental: { kind: [0, 1, 1] },
  },
  { name: "Esus4", notes: 3 },
  {
    name: "E7sus4",
    notes: 4,
    lineF: { position: [false, false, false, true] },
  },
  { name: "Em", notes: 3 },
  { name: "Em7", notes: 4, lineF: { position: [false, false, false, true] } },
  {
    name: "EmM7",
    notes: 4,
    lineF: { position: [false, false, false, true] },
    accidental: { kind: [0, 0, 0, 1] },
  },
  {
    name: "Em7-5",
    notes: 4,
    lineF: { position: [false, false, false, true] },
    accidental: { kind: [0, 0, 2] },
  },
  {
    name: "Em6",
    notes: 4,
    lineF: { position: [false, false, false, true] },
    accidental: { kind: [0, 0, 0, 1] },
  },
  {
    name: "Eaug",
    notes: 3,
    accidental: { kind: [0, 1, 1] },
  },
  {
    name: "Edim",
    notes: 4,
    lineF: { position: [false, false, false, true] },
    accidental: { kind: [0, 0, 2, 2] },
  },
  { name: "F", notes: 3, lineF: { position: [false, false, true] } },
  {
    name: "F7",
    notes: 4,
    lineF: { position: [false, false, true, true] },
    accidental: { kind: [0, 0, 0, 2] },
  },
  { name: "FM7", notes: 4, lineF: { position: [false, false, true, true] } },
  { name: "F6", notes: 4, lineF: { position: [false, false, true] } },
  { name: "Fadd9", notes: 4, lineF: { position: [false, false, false, true] } },
  {
    name: "Fsus4",
    notes: 3,
    lineF: { position: [false, false, true] },
    accidental: { kind: [0, 2] },
  },
  {
    name: "F7sus4",
    notes: 4,
    lineF: { position: [false, false, true, true] },
    accidental: { kind: [0, 2, 0, 2] },
  },
  {
    name: "Fm",
    notes: 3,
    lineF: { position: [false, false, true] },
    accidental: { kind: [0, 2] },
  },
  {
    name: "Fm7",
    notes: 4,
    lineF: { position: [false, false, true, true] },
    accidental: { kind: [0, 2, 0, 2] },
  },
  {
    name: "FmM7",
    notes: 4,
    lineF: { position: [false, false, true, true] },
    accidental: { kind: [0, 2] },
  },
  {
    name: "Fm7-5",
    notes: 4,
    lineF: { position: [false, false, true, true] },
    accidental: { kind: [0, 2, 2, 2] },
  },
  {
    name: "Fm6",
    notes: 4,
    lineF: { position: [false, false, true] },
    accidental: { kind: [0, 2] },
  },
  {
    name: "Faug",
    notes: 3,
    lineF: { position: [false, false, true] },
    accidental: { kind: [0, 0, 1] },
  },
  {
    name: "Fdim",
    notes: 4,
    lineF: { position: [false, false, true] },
    accidental: { kind: [0, 2, 2] },
  },
  {
    name: "F♯",
    name2: "F#",
    notes: 3,
    accidental: { kind: [1, 1, 1] },
    lineF: { position: [false, false, true] },
  },
  {
    name: "F♯7",
    name2: "F#7",
    notes: 4,
    accidental: { kind: [1, 1, 1] },
    lineF: { position: [false, false, true, true] },
  },
  {
    name: "F♯M7",
    name2: "F#M7",
    notes: 4,
    lineF: { position: [false, false, true, true] },
    accidental: { kind: [1, 1, 1, 1] },
  },
  {
    name: "F♯6",
    name2: "F#6",
    notes: 4,
    lineF: { position: [false, false, true] },
    accidental: { kind: [1, 1, 1, 1] },
  },
  {
    name: "F♯add9",
    name2: "F#add9",
    notes: 4,
    lineF: { position: [false, false, false, true] },
    accidental: { kind: [1, 1, 1, 1] },
  },
  {
    name: "F♯sus4",
    name2: "F#sus4",
    notes: 3,
    lineF: { position: [false, false, true] },
    accidental: { kind: [1, 0, 1] },
  },
  {
    name: "F♯7sus4",
    name2: "F#7sus4",
    notes: 4,
    lineF: { position: [false, false, true, true] },
    accidental: { kind: [1, 0, 1] },
  },
  {
    name: "F♯m",
    name2: "F#m",
    notes: 3,
    lineF: { position: [false, false, true] },
    accidental: { kind: [1, 0, 1] },
  },
  {
    name: "F♯m7",
    name2: "F#m7",
    notes: 4,
    lineF: { position: [false, false, true, true] },
    accidental: { kind: [1, 0, 1] },
  },
  {
    name: "F♯mM7",
    name2: "F#mM7",
    notes: 4,
    lineF: { position: [false, false, true, true] },
    accidental: { kind: [1, 0, 1, 1] },
  },
  {
    name: "F♯m7-5",
    name2: "F#m7-5",
    notes: 4,
    lineF: { position: [false, false, true, true] },
    accidental: { kind: [1] },
  },
  {
    name: "F♯m6",
    name2: "F#m6",
    notes: 4,
    lineF: { position: [false, false, true] },
    accidental: { kind: [1, 0, 1, 1] },
  },
  {
    name: "F♯aug",
    name2: "F#aug",
    notes: 3,
    lineF: { position: [false, false, true] },
    accidental: { kind: [1, 1, 0] },
  },
  {
    name: "F♯dim",
    name2: "F#dim",
    notes: 4,
    lineF: { position: [false, false, true, true] },
    accidental: { kind: [1, 0, 0, 2] },
  },
  { name: "G", notes: 3, lineF: { position: [false, false, true] } },
  { name: "G7", notes: 4, lineF: { position: [false, false, true, true] } },
  {
    name: "GM7",
    notes: 4,
    lineF: { position: [false, false, true, true] },
    accidental: { kind: [0, 0, 0, 1] },
  },

  { name: "G6", notes: 4, lineF: { position: [false, false, true, true] } },
  { name: "Gadd9", notes: 4, lineF: { position: [false, false, false, true] } },
  { name: "Gsus4", notes: 3, lineF: { position: [false, true] } },
  {
    name: "G7sus4",
    notes: 4,
    lineF: { position: [false, false, true, true] },
  },
  {
    name: "Gm",
    notes: 3,
    lineF: { position: [false, false, true] },
    accidental: { kind: [0, 2] },
  },
  {
    name: "Gm7",
    notes: 4,
    lineF: { position: [false, false, true, true] },
    accidental: { kind: [0, 2] },
  },
  {
    name: "GmM7",
    notes: 4,
    lineF: { position: [false, false, true, true] },
    accidental: { kind: [0, 2, 0, 1] },
  },
  {
    name: "Gm7-5",
    notes: 4,
    lineF: { position: [false, false, true, true] },
    accidental: { kind: [0, 2, 2] },
  },
  {
    name: "Gm6",
    notes: 4,
    lineF: { position: [false, false, true, true] },
    accidental: { kind: [0, 2] },
  },
  {
    name: "Gaug",
    notes: 3,
    lineF: { position: [false, false, true] },
    accidental: { kind: [0, 0, 1] },
  },
  {
    name: "Gdim",
    notes: 4,
    lineF: { position: [false, false, true, true] },
    accidental: { kind: [0, 2, 2, 2] },
  },
  {
    name: "A♭",
    notes: 3,
    lineG: { position: [true, true] },
    accidental: { kind: [2, 0, 2] },
  },
  {
    name: "A♭7",
    notes: 4,
    lineG: { position: [true, true] },
    accidental: { kind: [2, 0, 2, 2] },
  },
  {
    name: "A♭M7",
    notes: 4,
    lineG: { position: [true, true] },
    accidental: { kind: [2, 0, 2] },
  },
  {
    name: "A♭6",
    notes: 4,
    lineG: { position: [true, true] },
    accidental: { kind: [2, 0, 2, 0] },
  },
  {
    name: "A♭add9",
    notes: 4,
    lineG: { position: [true, false, true] },
    accidental: { kind: [2, 2, 0, 2] },
  },
  {
    name: "A♭sus4",
    notes: 3,
    lineG: { position: [true, true] },
    accidental: { kind: [2, 2, 2] },
  },
  {
    name: "A♭7sus4",
    notes: 4,
    lineG: { position: [true, true] },
    accidental: { kind: [2, 2, 2, 2] },
  },
  {
    name: "A♭m",
    notes: 3,
    lineG: { position: [true, true] },
    accidental: { kind: [2, 2, 2] },
  },
  {
    name: "A♭m7",
    notes: 4,
    lineG: { position: [true, true] },
    accidental: { kind: [2, 2, 2, 2] },
  },
  {
    name: "A♭mM7",
    notes: 4,
    lineG: { position: [true, true] },
    accidental: { kind: [2, 2, 2] },
  },
  {
    name: "A♭m7-5",
    notes: 4,
    lineG: { position: [true, true] },
    accidental: { kind: [2, 2, 0, 2] },
  },
  {
    name: "A♭m6",
    notes: 4,
    lineG: { position: [true, true] },
    accidental: { kind: [2, 2, 2] },
  },
  {
    name: "A♭aug",
    notes: 3,
    lineG: { position: [true, true] },
    accidental: { kind: [2] },
  },
  {
    name: "A♭dim",
    notes: 4,
    lineG: { position: [true, true] },
    accidental: { kind: [2, 2] },
  },
  {
    name: "A",
    notes: 3,
    lineG: { position: [true, true] },
    accidental: { kind: [0, 1] },
  },
  {
    name: "A7",
    notes: 4,
    lineG: { position: [true, true] },
    accidental: { kind: [0, 1] },
  },
  {
    name: "AM7",
    notes: 4,
    lineG: { position: [true, true] },
    accidental: { kind: [0, 1, 0, 1] },
  },
  {
    name: "A6",
    notes: 4,
    lineG: { position: [true, true] },
    accidental: { kind: [0, 1, 0, 1] },
  },
  {
    name: "Aadd9",
    notes: 4,
    lineG: { position: [true, true] },
    accidental: { kind: [0, 0, 1] },
  },
  { name: "Asus4", notes: 3, lineG: { position: [true, true] } },
  {
    name: "A7sus4",
    notes: 4,
    lineG: { position: [true, true] },
  },
  { name: "Am", notes: 3, lineG: { position: [true, true] } },
  { name: "Am7", notes: 4, lineG: { position: [true, true] } },
  {
    name: "AmM7",
    notes: 4,
    lineG: { position: [true, true] },
    accidental: { kind: [0, 0, 0, 1] },
  },
  {
    name: "Am7-5",
    notes: 4,
    lineG: { position: [true, true] },
    accidental: { kind: [0, 0, 2] },
  },
  {
    name: "Am6",
    notes: 4,
    lineG: { position: [true, true] },
    accidental: { kind: [0, 0, 0, 1] },
  },
  {
    name: "Aaug",
    notes: 3,
    lineG: { position: [true, true] },
    accidental: { kind: [0, 1, 1] },
  },
  {
    name: "Adim",
    notes: 4,
    lineG: { position: [true, true] },
    accidental: { kind: [0, 0, 2, 2] },
  },

  {
    name: "B♭",
    notes: 3,
    lineG: { position: [false, true] },
    accidental: { kind: [2] },
  },
  {
    name: "B♭7",
    notes: 4,
    lineG: { position: [false, true] },
    accidental: { kind: [2, 0, 0, 2] },
  },
  {
    name: "B♭M7",
    notes: 4,
    lineG: { position: [false, true] },
    accidental: { kind: [2] },
  },
  {
    name: "B♭6",
    notes: 4,
    lineG: { position: [false, true] },
    accidental: { kind: [2] },
  },
  {
    name: "B♭add9",
    notes: 4,
    lineG: { position: [false, true] },
    accidental: { kind: [2] },
  },
  {
    name: "B♭sus4",
    notes: 3,
    lineG: { position: [false, true] },
    accidental: { kind: [2, 2] },
  },
  {
    name: "B♭7sus4",
    notes: 4,
    lineG: { position: [false, true] },
    accidental: { kind: [2, 2, 0, 2] },
  },
  {
    name: "B♭m",
    notes: 3,
    lineG: { position: [false, true] },
    accidental: { kind: [2, 2] },
  },
  {
    name: "B♭m7",
    notes: 4,
    lineG: { position: [false, true] },
    accidental: { kind: [2, 2, 0, 2] },
  },
  {
    name: "B♭mM7",
    notes: 4,
    lineG: { position: [false, true] },
    accidental: { kind: [2, 2] },
  },
  {
    name: "B♭m7-5",
    notes: 4,
    lineG: { position: [false, true] },
    accidental: { kind: [2, 2, 2, 2] },
  },
  {
    name: "B♭m6",
    notes: 4,
    lineG: { position: [false, true] },
    accidental: { kind: [2, 2] },
  },
  {
    name: "B♭aug",
    notes: 3,
    lineG: { position: [false, true] },
    accidental: { kind: [2, 0, 1] },
  },
  {
    name: "B♭dim",
    notes: 4,
    lineG: { position: [false, true] },
    accidental: { kind: [2, 2, 2] },
  },
  {
    name: "B",
    notes: 3,
    accidental: { kind: [0, 1, 1] },
    lineG: { position: [false, true] },
  },
  {
    name: "B7",
    notes: 4,
    accidental: { kind: [0, 1, 1] },
    lineG: { position: [false, true] },
  },
  {
    name: "BM7",
    notes: 4,
    lineG: { position: [false, true] },
    accidental: { kind: [0, 1, 1, 1] },
  },
  {
    name: "B6",
    notes: 4,
    lineG: { position: [false, true] },
    accidental: { kind: [0, 1, 1, 1] },
  },
  {
    name: "Badd9",
    notes: 4,
    lineG: { position: [false, true] },
    accidental: { kind: [0, 1, 1, 1] },
  },
  {
    name: "Bsus4",
    notes: 3,
    lineG: { position: [false, true] },
    accidental: { kind: [0, 0, 1] },
  },
  {
    name: "B7sus4",
    notes: 4,
    lineG: { position: [false, true] },
    accidental: { kind: [0, 0, 1] },
  },
  {
    name: "Bm",
    notes: 3,
    lineG: { position: [false, true] },
    accidental: { kind: [0, 0, 1] },
  },
  {
    name: "Bm7",
    notes: 4,
    lineG: { position: [false, true] },
    accidental: { kind: [0, 0, 1] },
  },
  {
    name: "BmM7",
    notes: 4,
    lineG: { position: [false, true] },
    accidental: { kind: [0, 0, 1, 1] },
  },
  {
    name: "Bm7-5",
    notes: 4,
    lineG: { position: [false, true] },
  },
  {
    name: "Bm6",
    notes: 4,
    lineG: { position: [false, true] },
    accidental: { kind: [0, 0, 1, 1] },
  },
  {
    name: "Baug",
    notes: 3,
    lineG: { position: [false, true] },
    accidental: { kind: [0, 1] },
  },
  {
    name: "Bdim",
    notes: 4,
    lineG: { position: [false, true] },
    accidental: { kind: [0, 0, 0, 2] },
  },
];
